import { createGlobalStyle } from 'styled-components';
import { fonts, fontFace } from '@eriksdigital/atomic-ui/styles';

const GlobalStyles = createGlobalStyle`
  ${fontFace}

  * {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  body {
    font-family: ${fonts.fontFamily.primary};
    font-weight: ${fonts.fontWeight.normal};
    min-width: 1000px;
  }

  body,
  p,
  ul,
  h1,
  h2,
  h3,
  h4,
  h5,
  fieldset,
  label {
    margin: 0;
    padding: 0;
  }

  ul {
    list-style-type: none;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  fieldset {
    border: none;
  }

  input[type=number]::-webkit-inner-spin-button, 
  input[type=number]::-webkit-outer-spin-button { 
    -webkit-appearance: none; 
    margin: 0; 
  }

  select {
    appearance: none;
    background-image: none;
    background: transparent;
  }

  select::-ms-expand {
    visibility: hidden;
  }

  *::-webkit-scrollbar {
    width: 8px;
    background: transparent;
  }
  *::-webkit-scrollbar-thumb {
    background: #C8CCD6;
    border-radius: 8px;
    height:30px;
  }
  
  *::-webkit-scrollbar-track-piece
  {
     display:none;
  }  
`;

export default GlobalStyles;
